import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ContactForm from '@/pages/about/components/ContactForm';

const SCOPES = [
  { icon: 'ri-film-line', title: '电影', desc: '院线热映、经典佳片与多元题材电影内容展示。' },
  { icon: 'ri-tv-2-line', title: '电视剧', desc: '古装、悬疑、都市、历史等热门剧集持续更新。' },
  { icon: 'ri-mic-line', title: '综艺', desc: '真人秀、音乐、美食、选秀等综艺节目一网打尽。' },
];

const STEPS = [
  { step: '01', title: '浏览与查找', desc: '通过顶部导航或首页分类入口快速进入感兴趣的板块，也可按年份、地区、题材筛选。' },
  { step: '02', title: '查看详情', desc: '点击任意影视卡片进入详情页，查看导演、主演、类型、简介与更新时间等信息。' },
  { step: '03', title: '收藏与分享', desc: '收藏喜欢的内容保存在本地，或复制详情页链接与好友分享你的发现。' },
];

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 神马视频';
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <Header />

      <main className="flex-1 w-full px-4 md:px-8 py-6 md:py-8">
        <div className="rounded-lg bg-gradient-to-br from-primary-900 to-primary-700 p-6 md:p-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-xs font-medium text-background-100">
            <i className="ri-information-line"></i>
            关于神马视频
          </span>
          <h1 className="mt-4 text-2xl md:text-4xl font-bold text-background-50">多元影视内容平台</h1>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed max-w-3xl">
            神马视频是集最新电影、电视剧、综艺节目资源于一体的多元影视内容平台，核心目标用户是喜欢在线观看和下载影视剧的广大影视爱好者，尤其聚焦追剧用户、影视资源搜索需求者及综艺节目粉丝。
          </p>
          <p className="mt-3 text-sm md:text-base text-background-300 leading-relaxed max-w-3xl">
            我们希望提供丰富全面的影视资源展示，方便你快速查找、浏览及了解影视内容信息，提升观看决策效率。
          </p>
        </div>

        <section className="mt-8">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-accent-500"></span>
            内容范围
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {SCOPES.map((scope) => (
              <div key={scope.title} className="rounded-lg bg-background-50 border border-background-200/80 p-5">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${scope.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-950">{scope.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">{scope.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-primary-500"></span>
            使用说明
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {STEPS.map((item) => (
              <div key={item.step} className="rounded-lg bg-background-50 border border-background-200/80 p-5">
                <span className="text-2xl font-bold text-accent-500">{item.step}</span>
                <h3 className="mt-2 text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8 rounded-lg bg-secondary-100 border border-secondary-200 p-5 md:p-6">
          <h2 className="text-base md:text-lg font-bold text-foreground-950 flex items-center gap-2">
            <i className="ri-alert-line text-accent-600"></i>
            免责声明
          </h2>
          <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
            本站仅提供影视内容的信息展示与导航服务，<strong>不提供视频播放及下载功能</strong>。站内影视数据为演示用途的虚构示例内容，收藏功能基于浏览器本地存储仅作演示，搜索功能为前端模拟匹配。请勿将本站内容用于任何商业用途。
          </p>
        </section>

        <section className="mt-8">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-accent-500"></span>
            联系我们
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-6">
            <div className="rounded-lg bg-background-50 border border-background-200/80 p-5">
              <h3 className="text-base font-semibold text-foreground-950">联系方式</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                如果你对本站内容有任何建议、纠错或合作意向，欢迎通过右侧表单留言，我们会尽快与你联系。
              </p>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-mail-line text-accent-600"></i>
                  contact@shenmavideo.demo
                </li>
                <li className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-time-line text-accent-600"></i>
                  工作日 09:00 - 18:00
                </li>
                <li className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-map-pin-line text-accent-600"></i>
                  线上服务平台
                </li>
              </ul>
              <Link
                to="/search"
                className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-600 cursor-pointer"
              >
                先去搜索影视内容
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <ContactForm />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}